import React from 'react';
import users from '../../../../services/users';
import './style.css';
import LoadingComponent from '../../../../components/loading/index';
import AddUserModal from './components/add-user-modal/index';
import ConfirmComponent from '../../../../components/confirm/index';
//import userThumbnail from '../../../../user.png'
import DropdownComponent from '../../../../components/dropdown/index';
const images = require("../../../../images.json")
const userThumbnail = images.user

export default class CreateAccountComponent extends React.Component {
    state = {
        loading: true,
        users: [],
        display: [],
        modal: "",
        user: null,
        status: "activo"
    }

    filterMenu = [
        {
            text: "Activos",
            onClick: () => this.filterDisplay("activo")
        },
        {
            divider: true
        },
        {
            text: "Inactivos",
            onClick: () => this.filterDisplay("inactivo")
        }
    ]

    componentWillMount() {
        users.find({role: "user"}, (err, users) => {
            let display = users.filter(user => user.status === "activo")
            this.setState({loading: false, users: users, display: display})
        });
    }

    filterDisplay = (status) => {
        let display = this.state.users.filter(user => user.status === status)
        this.setState({display: display, status: status})
    }

    openModal = (modal, user = null) => this.setState({modal: modal, user: user})
    closeModal = () => this.setState({modal: '', user: null})

    getImage = (user) => {
        return user.image ? user.image : userThumbnail;
    }

    renderUser = (user, index) => {
        return (
            <tr key={index}>
                <td>
                    <figure className="image is-32x32 user-avatar">
                        <img alt="avatar" src={this.getImage(user)} />
                    </figure>
                </td>
                <td>{user.userName}</td>
                <td>{user.status}</td>
                <td>
                    {user.status == "activo" ?
                    <button className="delete-button" onClick={() => this.openModal("delete", user)}>
                        <i className="fas fa-times"></i>
                    </button> :
                    <button className="restaure-button" onClick={() => this.openModal("restaure", user)}>
                        <i className="fas fa-undo-alt"></i>
                    </button>}
                </td>
            </tr>
        );
    }

    get confirmText() {
        if(this.state.user)
            return `¿Está seguro de que desea desactivar al usuario ${this.state.user.userName}?`
        else
            return ""
    }

    get restaureText() {
        if(this.state.user)
            return `¿Está seguro de que desea activar al usuario ${this.state.user.userName}?`
        else
            return ""
    }

    deleteUser = () => {
        users.update({_id: this.state.user._id}, { $set: {status: "inactivo"} }, (err, user) => {
            let users = Object.assign([],this.state.users);
            let index = users.findIndex(usr => usr._id === this.state.user._id);
            let display = Object.assign([],this.state.display)
            let index2 = display.findIndex(usr => usr._id === this.state.user._id)
            if(index !== -1) {
                users[index].status = "inactivo";
                display.splice(index2, 1);
                this.setState({users: users,display: display, user: null})
            }
        })
    }

    restaureUser = () => {
        users.update({_id: this.state.user._id}, { $set: {status: "activo"} }, (err, user) => {
            let users = Object.assign([],this.state.users);
            let index = users.findIndex(usr => usr._id === this.state.user._id);
            let display = Object.assign([],this.state.display)
            let index2 = display.findIndex(usr => usr._id === this.state.user._id)
            if(index !== -1) {
                users[index].status = "activo";
                display.splice(index2, 1);
                this.setState({users: users, display: display, user: null})
            }
        })
    }

    addUser = (user) => {
        if(user.status == this.state.status)
            this.setState({users: this.state.users.concat(user), display: this.state.display.concat(user)})
        else
            this.setState({users: this.state.users.concat(user)})
    }

    render() {
        if(this.state.loading)
            return <LoadingComponent />

        return (
            <React.Fragment>
                <div className="CreateAccount">
                    <div className="card">
                        <header className="card-header">
                            <h2 className="card-header-title">
                                Cuentas
                            </h2>
                            <div style={{padding: 0}} className="card-header-icon header-button">
                                <DropdownComponent menu={this.filterMenu}
                                    title={<i className="fas fa-filter hover-color" aria-hidden="true"></i>}
                                    color="#449c8c" />
                            </div>
                            <a className="card-header-icon header-button"
                                onClick={() => this.openModal("add")}>
                                <span className="icon">
                                    <i className="fas fa-plus" aria-hidden="true"></i>
                                </span>
                            </a>
                        </header>
                        <div className="card-content">
                            {this.state.display.length > 0 ?
                            <table className="table is-fullwidth">
                                <thead>
                                    <tr>
                                        <th>Avatar</th>
                                        <th>Nombre</th>
                                        <th>Estado</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.display.map(this.renderUser)}
                                </tbody>
                            </table> :
                            <p>No hay cuentas...</p>}
                        </div>
                    </div>
                </div>
                <AddUserModal close={this.closeModal}
                    isActive={this.state.modal === "add"}
                    hasClose={true}
                    addUser={this.addUser}
                    />
                <ConfirmComponent header="Eliminar"
                    close={this.closeModal}
                    isActive={this.state.modal === "delete"}
                    text={this.confirmText}
                    onSubmit={this.deleteUser}
                />
                <ConfirmComponent header="Restaurar"
                    close={this.closeModal}
                    isActive={this.state.modal === "restaure"}
                    text={this.restaureText}
                    onSubmit={this.restaureUser}
                />
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/create-account/index.js